import {AddOnSearchReloadOperation} from './search';

const searchMapQuery = '[data-search-map]';
const mapConfigurationKey = 'search-map-config';
const mapItemsKey = 'search-map-items';

interface MapItem {
    url: string;
    position: Position;
    title: string;
    icon?: string;
    map?: object;
}

interface MapConfiguration {
    zoom: number;
    center: Position;
}

interface Position {
    lat: number;
    lng: number;
}

bindCreateMaps($('body'));

AddOnSearchReloadOperation(bindCreateMaps);

function bindCreateMaps(scope: JQuery<HTMLElement>) {
    scope.find(searchMapQuery).each((index, mapElement) => {
        const mapJQuery = $(mapElement);
        const mapConfiguration: MapConfiguration = parseObject(mapJQuery.data(mapConfigurationKey));
        const mapItems: MapItem[] = parseObject(mapJQuery.data(mapItemsKey));

        const map = new google.maps.Map(mapElement, mapConfiguration);

        for (let i = 0; i < mapItems.length; i++) {
            CreateMarker(mapItems[i], map);
        }
    });
}

function parseObject(value: any) {
    return JSON.parse(decodeHtml(value));
}

function decodeHtml(value: any): string {
    var textArea = document.createElement('textarea');
    textArea.innerHTML = value;
    return textArea.value;
}

function CreateMarker(item: MapItem, map): void {
    item.map = map;
    let marker = new google.maps.Marker(item);
    marker.addListener('click', function() {
        window.open(item.url, '_blank');
    });
}
